import { ApiProperty } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import { IsBoolean, IsUUID, MaxLength } from 'class-validator';
import { CommonEntityDto } from '../../../common/dto/common-entity.dto';
import { SpModelNameInterface } from '../interfaces/sp-model-name.interface';
import { SubdivisionDto } from '../../../subdivision/dto/subdivision.dto';
import { ModelDto } from '../../../model/dto/model.dto';

export class SpModelNameDto
  extends CommonEntityDto
  implements SpModelNameInterface
{
  @ApiProperty({ required: true })
  @MaxLength(250, {
    message: 'The spName field is required and must not exceed 250 characters',
  })
  spName!: string;

  @ApiProperty({ type: 'string', name: 'Sp Name ID' })
  spNameId!: string;

  @ApiProperty({ required: true })
  @IsUUID()
  modelId!: string;

  @ApiProperty({
    type: 'boolean',
    default: true,
    title: 'Active?',
    description: 'True if builder name is active',
  })
  @IsBoolean()
  active!: boolean;

  @ApiProperty({ required: true })
  @IsUUID()
  subdivisionId!: string;

  @ApiProperty({ type: () => ModelDto })
  @Type(() => ModelDto)
  model?: ModelDto;

  @ApiProperty({ type: SubdivisionDto })
  @Type(() => SubdivisionDto)
  subdivision?: SubdivisionDto;
}
